import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

export function ActionConfirmationDialog({
  open,
  title,
  paragraphs = [],
  confirmLabel = "Start",
  cancelLabel = "Cancel",
  confirmColor = "primary",
  onConfirm,
  onCancel,
}) {
  return (
    <Dialog
      open={Boolean(open)}
      onClose={onCancel}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>{title}</DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          {paragraphs.map((paragraph, index) => (
            <Typography key={index}>
              {paragraph}
            </Typography>
          ))}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel}>
          {cancelLabel}
        </Button>

        <Button
          variant="contained"
          color={confirmColor}
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
